import { Button, keyframes } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useTranslation } from 'react-i18next';

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

interface TasksRefreshButtonProps {
  onClick: () => void;
  refreshing?: boolean;
}

export default function TasksRefreshButton({ onClick, refreshing }: TasksRefreshButtonProps) {
  const { t } = useTranslation();

  return (
    <Button
      size="small"
      variant="outlined"
      onClick={onClick}
      disabled={refreshing}
      startIcon={
        <RefreshIcon
          sx={{
            fontSize: 18,
            animation: refreshing ? `${spin} 0.8s linear infinite` : 'none',
          }}
        />
      }
      sx={{
        borderRadius: 2,
        textTransform: 'none',
        fontSize: '0.8125rem',
        fontWeight: 500,
        borderColor: '#E2E8F0',
        color: 'text.secondary',
        flexShrink: 0,
        '&:hover': { borderColor: '#93C5FD', color: '#3B82F6', bgcolor: '#F0F9FF' },
      }}
    >
      {t('tasks.refresh')}
    </Button>
  );
}
